module.exports = __webpack_public_path__ + "fonts/TTFirs-Light.fa3a876c.woff";